import Checkbox from "./Checkbox";
import { Select, InputNumber, Row, Space } from "antd";
import data from "../../resources/SLLineList";
import StandardSubSettings from "./StandardSubSettings";

const { Option } = Select;

const SLSettings = ({ settings, saveSettings }) => {
  let localSettings = StandardSubSettings(settings, "SL");
  let notification = localSettings.notification;

  const allLines = [];
  for (let i = 0; i < data.length; i++) {
    allLines.push(
      <Option key={data[i]} value={data[i]}>
        {data[i]}
      </Option>
    );
  }

  return (
    <div>
      <Row>
        <Checkbox
          name="EnableNotification"
          text="Aktivera notiser vid SL"
          def={notification}
          onChange={() => {
            notification = !notification;
            localSettings.notification = notification;
            saveSettings(localSettings);
          }}
        />
      </Row>
      <Row>
        <Select
          mode="multiple"
          showSearch
          style={{ width: "75%" }}
          placeholder={"Välj linjer"}
          defaultValue={localSettings.line}
          onChange={(value) => {
            localSettings.line = value;
            saveSettings(localSettings);
          }}
        >
          {allLines}
        </Select>
      </Row>
      <Row style={{ padding: "10px" }}>
        <Space>
            <p style={{ margin: "10px 0px 0px 0px" }}>
                {" "}
                Avisera om ny data finns inom:{" "}
            </p>
          <InputNumber
            min={0}
            defaultValue={localSettings.newDataHour}
            onChange={(value) => {
                if(value===null){value = 0;}
              localSettings.newDataHour = value;
              saveSettings(localSettings);
            }}
            step={0.5}
          />
            <p style={{ margin: "10px 0px 0px 0px" }}>timmar</p>
        </Space>
      </Row>
    </div>
  );
};
export default SLSettings;
